/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React, {useState, useEffect} from "react";

import InThePress from "./InThePress";

import {getAppLink} from "api";

import {
  WealthyEnv,
  handleApiError
} from "helpers";

const businessInsider = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-in-the-press-business-standard.jpg`;
const etTimes = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-in-the-press-economic-times.webp`;
const incImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-in-the-press-inc-4.webp`;
const freePress = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-in-the-press-free-press.webp`;
const vcCircle = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-in-the-press-vc-circle.webp`;

const inThePressData = [
  {
    id: 1,
    tabImageUrl: businessInsider,
    heading: "Wealthy.in raises Rs 56 crore in funding round led by Alpha Wav",
    description: "Bengaluru-based wealth management platform Wealthy.in on Tuesday said it has raised Rs 56 crore in Series A round of funding led by Alpha Wave Incubation.",
    detailImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-in-the-press-bs-detail-image.png`
  },
  {
    id: 2,
    tabImageUrl: etTimes,
    heading: "Wealth management platform Wealthy raises $7.5 million funding led by Alpha Wave",
    description: "Mumbai: Wealth management platform Wealthy on Wednesday said it has raised $7.5 million in a funding round led by Alpha Wave Incubation (AWI). Backed by Abu Dhabi investment vehicle ADQ’s venture platform, AWI is managed by Alpha Wave Global (formerly Falcon Edge Capital).",
    detailImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-in-the-press-et-detail-image.png`
  },
  {
    id: 3,
    tabImageUrl: incImage,
    heading: "Alpha Wave Incubation, Savrola Group Pump $7.5 Mn In Wealth Management Startup Wealthy",
    description: "Wealth management startup Wealthy has raised $7.5 Mn in its Series A round led by Alpha Wave Incubation (AWI). AWI is backed by ADQ’s venture platform and managed by Alpha Wave Global (formerly known as Falcon Edge Capital).",
    detailImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-in-the-press-inc-detail-image.png`
  },
  {
    id: 4,
    tabImageUrl: freePress,
    heading: "Wealthy.in raises $7.5 mn Series A round led by Alpha Wave, others",
    description: "Wealthy.in, a Bengaluru-based WealthTech platform, announced it has raised $7.5 million in Series A round of funding led by Alpha Wave Incubation (AWI). AWI is backed by ADQ’s venture platform, and managed by Alpha Wave Global (formerly known as Falcon Edge Capital).",
    detailImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-in-the-press-inc-detail-image.png`
  },
  {
    id: 5,
    tabImageUrl: vcCircle,
    heading: "Alpha Wave leads $7.5 mn funding in wealth tech platform Wealthy.in",
    description: "Buildwealth Technologies Pvt Ltd, which runs wealth tech platform Wealthy.in on Wednesday said it has secured $7.5 million (around Rs 56 crore) as a part of its series A funding led by Alpha Wave Incubation (AWI).",
    detailImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-in-the-press-vc-detail-image.png`
  }
];

const InThePressContainer = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [formData, setFormData] = useState({
    phoneNumber: ""
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const contentElement = document.getElementById(`tab-content${activeTab}`);

    if (contentElement.classList.contains("in-view")) {
      contentElement.classList.remove("in-view");
      contentElement.classList.add("fade-in");
    }
    setTimeout(() => {
      contentElement.classList.add("in-view");
    }, 100);
  }, [activeTab]);

  useEffect(() => {
    const landingPageUrl = window.location.href;
    setFormData({...formData, landingPageUrl});
  }, []);

  useEffect(() => {
    if (showModal) {
      document.body.classList.add("hide-scroll");
    } else {
      document.body.classList.remove("hide-scroll");
    }
  }, [showModal]);

  const onChangeHandler = (event) => {
    const {
      name,
      value
    } = event.target;

    if (name === "phoneNumber" && value.length > 10) {
      return;
    }

    setFormData({
      ...formData,
      [name]: value
    });
  };

  const getUtmTags = () => {
    let utmSource;
    let utmMedium;
    let utmContent;
    let utmCampaign;
    let utmTerm;
    if (window.location.search.includes("utm")) {
      const param = new URLSearchParams(window.location.search);

      const getUtmValue = (utmTag) => {
        return param.get(utmTag) || "(none)";
      };

      utmSource = getUtmValue("utm_source");
      utmContent = getUtmValue("utm_content");
      utmCampaign = getUtmValue("utm_campaign");
      utmMedium = getUtmValue("utm_medium");
      utmTerm = getUtmValue("utm_term");
    } else {
      utmSource = "";
      utmContent = "";
      utmCampaign = "";
      utmMedium = "";
      utmTerm = "";
    }

    return {
      utmSource,
      utmMedium,
      utmContent,
      utmCampaign,
      utmTerm
    };
  };

  const submitHandler = async () => {
    try {
      setIsLoading(true);
      const utmTags = getUtmTags();
      const payload = {
        ...formData,
        ...utmTags
      };
      const response = await getAppLink(payload);
      if (response.status === 200) {
        setShowModal(true);
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <InThePress
      activeTab={activeTab}
      formData={formData}
      inThePressData={inThePressData}
      setActiveTab={setActiveTab}
      setShowModal={setShowModal}
      showModal={showModal}
      submitHandler={submitHandler}
      onChangeHandler={onChangeHandler}
    />
  );
};

export default InThePressContainer;
